const { createContext, useState, useContext } = require("react");

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [createBtn, setCreateBtn] = useState(false);
  const [timeSpentBtn, setTimeSpentBtn] = useState(false);
  const [renewBtn, setRenewBtn] = useState(false);
  const [showBagIcon, setShowBagIcon] = useState(false);
  const [showExpiryTimer, setShowExpiryTimer] = useState(false);

  const [bagCount, setBagCount] = useState(0);
  const [diaWeight, setDiaWeight] = useState(0);
  const [goldWeight, setGoldWeight] = useState(0);

  return (
    <ClientContext.Provider
      value={{
        createBtn,
        setCreateBtn,
        timeSpentBtn,
        setTimeSpentBtn,
        renewBtn,
        setRenewBtn,
        showBagIcon,
        setShowBagIcon,
        showExpiryTimer,
        setShowExpiryTimer,
        bagCount,
        setBagCount,
        diaWeight,
        setDiaWeight,
        goldWeight,
        setGoldWeight,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};

export const useClientContext = () => useContext(ClientContext);
